/* eslint-env browser */
/**
 * 번들이 "파싱 성공 후 실행을 시작"했음을 알리는 부수효과 모듈.
 *
 * index.ejs <head> 의 ES5 가드(window.onerror)는 이 플래그로
 *  - "우리 번들의 파싱 실패(미지원 문법)"  → 미지원 브라우저 UI 노출
 *  - "파싱 성공 후의 런타임 에러"           → 기존 Sentry 처리에 위임
 * 를 구분한다.
 *
 * 미지원 문법이 있으면 번들 전체가 파싱 단계에서 SyntaxError 로 죽어
 * 단 한 줄도 실행되지 않으므로, 이 플래그는 절대 세팅되지 않는다.
 * 따라서 반드시 index.js 의 "첫 번째 import" 로 두어 가장 이른 시점에 실행되어야 한다.
 */
// eslint-disable-next-line no-underscore-dangle
window.__GW_PARSED__ = true
